export default __webpack_public_path__ + "static/media/boton-BAC.8b0ff056.png";